/* Domain Black, interactive buttons. Pairs with db-buttons.css. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Each fragrance's glow color, as R, G, B */
  var SCENT = {
    'kingdom': '200, 202, 212',
    'sovereign': '176, 112, 72',
    'celestial': '127, 163, 216',
    'crown': '233, 215, 174',
    'empire': '232, 130, 60',
    'the-discovery-set': '201, 211, 224'
  };
  var FIVE = ['kingdom', 'sovereign', 'celestial', 'crown', 'empire'];

  var FX = [
    '.db-pill',
    '.db-discovery__cta',
    "[class^='db-footer-'] .db-footer__pill button",
    '.contact .button',
    '.product-form__submit'
  ].join(',');
  var MAGNET = '.db-pill, .db-discovery__cta, .db-world__link';

  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m && SCENT[m[1]] ? m[1] : null;
  }

  function clipOf(el) {
    var c = el.querySelector(':scope > .db-clip');
    if (!c) {
      c = document.createElement('span');
      c.className = 'db-clip';
      c.setAttribute('aria-hidden', 'true');
      var s = document.createElement('span');
      s.className = 'db-sheen';
      c.appendChild(s);
      el.appendChild(c); /* last, so the theme's own "first span" lookups still find the label */
    }
    return c;
  }

  function magnet(el) {
    if (el.dataset.dbMagnet) return;
    el.dataset.dbMagnet = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--db-mx', (x * 8).toFixed(1) + 'px');
      el.style.setProperty('--db-my', (y * 6).toFixed(1) + 'px');
    });
    el.addEventListener('pointerleave', function () {
      el.style.setProperty('--db-mx', '0px');
      el.style.setProperty('--db-my', '0px');
    });
  }

  function enhance(root) {
    root = root || document;

    root.querySelectorAll(FX).forEach(function (b) {
      if (b.dataset.dbFx) return;
      b.dataset.dbFx = '1';
      b.classList.add('db-fx');
      clipOf(b);
    });

    root.querySelectorAll('.db-world__link').forEach(function (a) {
      if (a.dataset.dbEnter) return;
      a.dataset.dbEnter = '1';
      a.classList.add('db-enter');
      var u = document.createElement('span');
      u.className = 'db-underline';
      u.setAttribute('aria-hidden', 'true');
      a.appendChild(u);
    });

    root.querySelectorAll('.db-discovery__cta').forEach(function (a) {
      if (a.querySelector('.db-dots')) return;
      var d = document.createElement('span');
      d.className = 'db-dots';
      d.setAttribute('aria-hidden', 'true');
      /* five neutral tones, ivory to steel, one per fragrance */
      ['247, 249, 251', '226, 231, 238', '201, 211, 224', '159, 175, 199', '108, 122, 144'].forEach(function (tone, i) {
        var dot = document.createElement('i');
        dot.style.setProperty('--c', 'rgb(' + tone + ')');
        dot.style.setProperty('--i', i);
        d.appendChild(dot);
      });
      var arrow = a.querySelector('svg');
      if (arrow) a.insertBefore(d, arrow); else a.appendChild(d);
    });

    root.querySelectorAll('.product-form__submit').forEach(function (btn) {
      var label = btn.querySelector(':scope > span:not(.db-clip)');
      if (!label || label.classList.contains('db-label')) return;
      label.classList.add('db-label');
      label.insertAdjacentHTML('afterbegin',
        '<svg class="db-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>');
    });

    if (finePointer && !reduce) root.querySelectorAll(MAGNET).forEach(magnet);
  }

  /* Tap ripple on every enhanced button */
  document.addEventListener('pointerdown', function (e) {
    if (reduce) return;
    var b = e.target.closest('.db-fx');
    if (!b || b.disabled) return;
    var clip = clipOf(b);
    var r = b.getBoundingClientRect();
    var s = document.createElement('span');
    s.className = 'db-ripple';
    s.style.left = (e.clientX - r.left) + 'px';
    s.style.top = (e.clientY - r.top) + 'px';
    clip.appendChild(s);
    s.addEventListener('animationend', function () { s.remove(); });
  }, { passive: true });

  /* Cart icon bump */
  function bumpCart() {
    var c = document.getElementById('cart-icon-bubble');
    if (!c || reduce) return;
    c.classList.remove('db-bump');
    void c.offsetWidth;
    c.classList.add('db-bump');
  }

  function textNodeOf(label) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  /* ---------- Add to cart: a quiet confirmation ---------- */
  var holdDrawerUntil = 0;

  function swapLabel(label, textNode, text) {
    if (!textNode) return;
    if (reduce) { textNode.textContent = text; return; }
    label.classList.remove('db-swap');
    void label.offsetWidth;
    textNode.textContent = text;
    label.classList.add('db-swap');
  }

  function quietAdd(btn) {
    var pf = btn.closest('product-form');
    var label = btn.querySelector('.db-label');
    var textNode = label && textNodeOf(label);
    var original = textNode ? textNode.textContent : '';
    var clip = clipOf(btn);
    var line = clip.querySelector('.db-line');
    if (!line) {
      line = document.createElement('span');
      line.className = 'db-line';
      clip.appendChild(line);
    }
    btn.classList.remove('db-added', 'db-missed');
    void line.offsetWidth;
    btn.classList.add('db-filling');
    var started = Date.now();
    holdDrawerUntil = started + (reduce ? 0 : 900);

    var sawLoading = false, done = false;
    var obs = new MutationObserver(function () {
      if (btn.classList.contains('loading')) { sawLoading = true; return; }
      if (sawLoading) answer();
    });
    obs.observe(btn, { attributes: true, attributeFilter: ['class'] });
    var safety = setTimeout(answer, 10000);
    setTimeout(function () { if (!sawLoading) answer(true); }, 1500);

    function answer(noRequest) {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(safety);
      var err = pf && pf.querySelector('.product-form__error-message-wrapper');
      var failed = noRequest || (err && !err.hidden);
      var wait = Math.max(0, (reduce ? 0 : 500) - (Date.now() - started));
      setTimeout(function () {
        btn.classList.remove('db-filling');
        if (failed) {
          holdDrawerUntil = 0;
          btn.classList.add('db-missed');
          setTimeout(function () { btn.classList.remove('db-missed'); }, 1200);
          return;
        }
        btn.classList.add('db-added');
        swapLabel(label, textNode, 'Added to bag');
        bumpCart();
        setTimeout(function () {
          btn.classList.remove('db-added');
          swapLabel(label, textNode, original);
        }, 2200);
      }, wait);
    }
  }

  /* Give the confirmation a moment before the cart drawer slides in */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var CD = customElements.get('cart-drawer');
      if (!CD || CD.prototype.__dbHeld) return;
      CD.prototype.__dbHeld = true;
      var open = CD.prototype.open;
      CD.prototype.open = function () {
        var self = this, args = arguments, wait = holdDrawerUntil - Date.now();
        if (wait > 0) setTimeout(function () { open.apply(self, args); }, wait);
        else open.apply(this, args);
      };
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;

    if (form.matches('form[data-type="add-to-cart-form"]')) {
      var btn = form.querySelector('.product-form__submit');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('db-filling')) return;
      quietAdd(btn);
      return;
    }

    /* Newsletter sign-up and contact form: show that it is sending */
    var send = form.querySelector('.db-fx[type="submit"], button.db-fx, .db-fx');
    if (send && (!form.checkValidity || form.checkValidity())) {
      send.classList.add('db-sending');
      if (send.tagName === 'BUTTON' && !send.querySelector('.db-label')) {
        var isNewsletter = !!form.closest("[class^='db-footer-']");
        var t = send.childNodes;
        for (var i = 0; i < t.length; i++) {
          if (t[i].nodeType === 3 && t[i].textContent.trim()) {
            t[i].textContent = isNewsletter ? 'Joining' : 'Sending';
            break;
          }
        }
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  } else {
    enhance(document);
  }
  /* Re-run when the theme editor reloads a section */
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();
